import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {EventExt, SortType} from "@COMPONENTS/product/common/popup/desktop/EventListPopup/EventListPopup";
import * as style from "@COMPONENTS/style/productlist/departurepopupM";
import {FilterRightBox, SelectBox} from "@FRAMEWORK/ui/mobile/filter";
import {SubTitle} from "@FRAMEWORK/ui/mobile/text";
import React, {useState} from "react";
import EventList from "./EventList";

interface Props {
	eventsInCalendar: {
		minPrice: number;
		eventList: EventExt[];
	};
	currentDate: string;
}

// 일정 선택(출발일순, 낮은가격순, 높은가격순 상품 정렬)
const RATINGS = [
	{id: "departure", text: "출발일순", prop: "outStartDt", asc: true},
	{id: "lowPrice", text: "낮은가격순", prop: "sumPrice", asc: true},
	{id: "highPrice", text: "높은가격순", prop: "sumPrice", asc: false},
];

const SelectScheduleComponent = ({eventsInCalendar, currentDate}: Props) => {
	const [sort, setSort] = useState<SortType & {id: string}>(RATINGS[0]);
	const handleSort = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selected = e.target.selectedOptions[0];
		const {text, prop, asc} = selected.dataset;
		setSort({id: selected.value, text, prop, asc: asc === "true"});
	};

	return (
		<>
			<style.TitleWrap>
				<SubTitle>일정 선택</SubTitle>
				<FilterRightBox>
					<SelectBox>
						<select onChange={handleSort} value={sort.id}>
							{RATINGS.map((rating, index) => (
								<option
									key={index}
									value={rating.id}
									data-prop={rating.prop}
									data-asc={rating.asc}
									data-text={rating.text}
								>
									{rating.text}
								</option>
							))}
						</select>
					</SelectBox>
				</FilterRightBox>
			</style.TitleWrap>
			<style.ProductList>
				<EventList eventList={eventsInCalendar.eventList} sort={sort} currentDate={currentDate} />
			</style.ProductList>
		</>
	);
};

const SelectSchedule = (props: Props) => (
	<ErrorBoundary logMsg="DepartureDayPopup SelectSchedule Error">
		<SelectScheduleComponent {...props} />
	</ErrorBoundary>
);

export default SelectSchedule;
